import { Divider } from '@material-ui/core';
import styled, { css } from 'styled-components';

interface CircleProps {
  selected: boolean;
  color: string;
}

interface SizeProps {
  selected: boolean;
  disabled: boolean;
}

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
`;

export const Circle = styled.div<CircleProps>`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  padding: 0.15rem;
  border: 2px solid var(--color-gray-800);
  ${(props) =>
    props.selected &&
    css`
      border-color: var(--color-blue);
    `}
  background-color: ${(props) => props.color};
  background-clip: content-box;
  cursor: pointer;
`;

export const Size = styled.button<SizeProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  cursor: pointer;

  height: 24px;
  padding: 0.15rem;
  border: 2px solid var(--color-gray-800);
  background-clip: content-box;

  ${(props) =>
    props.selected &&
    css`
      border-color: var(--color-blue);
    `}

  p {
    user-select: none;
    font-size: 16px;
    line-height: 14px;
    white-space: nowrap;
    color: var(--color-gray-800);

    ${(props) =>
      props.selected &&
      css`
        color: var(--color-navy-blue);
      `}
  }
`;
